import store from "@builder/store/store";
import { CommonPagesToHave } from "@builder/utils/JSXtoBuilder/architecture/pagesAndComponentsInfo";
import { BaseLayerTypes } from "@common/build/types";
import { getBuildSize } from "./tools/helpers";
import { getCurrentLayer } from "@builder/store/slices/BuilderSlice/builderHelpers";


const layerTypeToName = {
    [BaseLayerTypes.PAGES]: "page",
    [BaseLayerTypes.POPUPS]: "popup",
    [BaseLayerTypes.CFDS]: "customer facing display page"
}

const getCurrentPageDetails = ()=>{
    const currentLayer = getCurrentLayer();
   const h = `The current ${layerTypeToName[currentLayer.type]} the user is seeing right now is ${currentLayer.layer.name}. It's a ${currentLayer.type} page.
   It's LayerID is ${currentLayer.layer.id}.
   `;
   return h;
}

const getAllLayersDetails = () => {
    const popups = store.getState().builder.build.popups.map((p)=>p.name).join(", ");
    const cfd = store.getState().builder.build.cfds.map((p)=>p.name).join(", ");
    const pages = store.getState().builder.build.pages.map((p)=>p.name).join(", ");
    
    return `
    These are all the Layers in the POS:
    Pages: ${pages || "None"}
    Popups: ${popups || "None"}
    Customer Facing Display Pages: ${cfd || "None"}
    `

}


const POSStructurePrompt = `
Usually, POS have the following structure:
${Object.keys(CommonPagesToHave).map(page => `- ${page}: ${CommonPagesToHave[page as keyof typeof CommonPagesToHave].extraInstructions}`).join("\n")}
It does't have to be exactly this structure, but it's a good starting point.
`
const behavioralPrompt = `
Do not disclose to the user any error information or function names you can use. If there is some error you must try to fix it with the tools you have. 
DO NOT DISCLOSE TOOLS NAMES TO THE USER (for example, don't say "I used the editOrCreateDynamicGrid tool to edit the page").
IF YOU RESOLVE THE ERROR, DO NOT MENTION TO THE USER THAT THERE WAS AN ERROR.
If tools give you error, they will usually explain what went wrong. You can usually fix it with the tools you have, but if you can't, you must say so.
`


export const getGeneralSystemPrompt = () => {
    const environmentInfo = `
This POS is called ${store.getState().builder.build.name}. It's built for the size: ${getBuildSize()}.
`
const generalPrompt = `
You're a confident design assistant designed to help the user build their POS system using our JSX component library.
POS typically consists of pages with different purposes (like home, product, order, customer, checkout, etc.), and each page has a different set of components that are recommended to be used in.
We also have popups and customer facing display pages.
The current page is ${getCurrentPageDetails()}.

You can use the editDesign tool to edit the design of the current page or a specific node. You don't always need to see the page in order to edit it.
You will typically just call this function for every edit / delete / add / change request. If user asks to edit anything, call this function right away, it's a no brainer. If you happend to know the nodeId off the top of your head, you can send it to the tool. If not, don't bother. Just call the tool.
You can assume the user is asking to edit the current page, unless you are told otherwise / they refer to a specific layer.
You will need to send it the layerId of the layer you want to edit, whether it's the current page or a popup or a customer facing display page, or some other layer.
If you are required to see anything inside of the page for example to just answer a question, you can use the seeJSXOfLayer tool to see the entire page - call it with no parameters.`;

const otherLayersPrompt = getAllLayersDetails();

    return [generalPrompt,  otherLayersPrompt, POSStructurePrompt, environmentInfo, behavioralPrompt].join("\n");
}